<template>
  <Legacy
    view="reports"
    action="freight"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Freight Reports (Old)',
      breadcrumb: {
        name: 'Freight (Old)',
        route: { name: 'reports-legacy-freight' }
      }
    }
  }
}
</script>
